import { render, staticRenderFns } from "./ModalNewCompany.vue?vue&type=template&id=1501f4e4&"
import script from "./ModalNewCompany.vue?vue&type=script&lang=js&"
export * from "./ModalNewCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports